<app-header-content-help-text [Heading]="'Parameters Management'" [helpText]="'Configure Attributes for Product Information'"></app-header-content-help-text>
<app-parameter-table-molecule [fuctionality]="'materials'"></app-parameter-table-molecule>
